<mat-form-field [appearance]="appearance">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input
    matInput
    [formControl]="innerControl"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    [errorStateMatcher]="controlErrorMatcher"
  />
  <mat-icon matSuffix *ngIf="includeIcon" (click)="openOptionsList()">access_time</mat-icon>
  <mat-error>{{ emitErrorMessage(control.errors) }}</mat-error>
</mat-form-field>

<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
  <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
    {{ displayFn(option) }}
  </mat-option>
</mat-autocomplete>
